import {
  idColumn,
  nameColumn,
  actionColumn,
  statusColumn,
  codeColumn,
} from "../../../../../utils/commonColumns";
import {
  textFormatEditor,
  generateColumn,
} from "../../../../../utils/commonFunctions";

const useColumnDefs = () => {
  return [
    idColumn,
    codeColumn,
    nameColumn,
    {
      ...generateColumn("", "industry_name"),
      ...textFormatEditor("industry_name"),
    },
    {
      ...generateColumn("", "description"),
      ...textFormatEditor("description"),
    },
    statusColumn,
    actionColumn,
  ];
};
export default useColumnDefs;
